import { useLayoutEffect } from 'react';

export const useOnElementWidthChange = (ref, callback) => {
  useLayoutEffect(() => {
    const currentRefValue = ref.current;

    if (currentRefValue) {
      const onResize = (entries) => {
        return callback(entries[0].contentRect.width);
      };

      const resizeObserver = new ResizeObserver(onResize);

      resizeObserver.observe(currentRefValue);

      return () => {
        resizeObserver.unobserve(currentRefValue);
      };
    }
  }, [ref, callback]);
};
